module.exports = __webpack_public_path__ + "static/media/pill_skill.3b9cb714.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/pill_skill.png
// module id = 322
// module chunks = 0